export const translations = {
  es: {
    nav: {
      inicio: 'Inicio',
      galeria: 'Galería',
      servicios: 'Servicios',
      historia: 'Historia',
      testimonios: 'Testimonios',
      contacto: 'Contacto',
      reservar: 'Reservar Cita',
      reservarCorto: 'Reservar',
    },
    hero: {
      title1: '¿',
      titleHighlight: 'Cansada',
      title2:
        ' de salir de un salón sintiéndote exactamente igual que cuando entraste?',
      subtitle1: 'El ',
      subtitleHighlight: 'estudio de belleza',
      subtitle2:
        ' de lujo en Sunnyside — el Luxury Hair Salon en Queens que está cambiando la forma en que las mujeres se sienten sobre sí mismas.',
      cta: 'RESERVAR MI CITA AHORA',
      socialProof: '4.8 ★ Google · 5.0 ★ Booksy · +93 reseñas',
    },
    opening: {
      p1_1: '¿Recuerdas la última vez que saliste de un salón y realmente ',
      p1_highlight: 'amaste',
      p1_2: ' lo que veías en el espejo?',
      p2_1: 'No el "está bien." No el "supongo que está bien así." Sino ese momento en que te miras y piensas: ',
      p2_highlight_1: '¡',
      p2_highlight_wow: 'Wow',
      p2_highlight_2: ', esto es exactamente lo que quería!',
      p3: 'Si ese momento ha sido difícil de encontrar… no es tu culpa.',
      p4: 'La realidad es que la mayoría de los salones trabajan rápido, trabajan en serie, y aplican color sin analizar verdaderamente tu cabello. Mezclan fórmulas genéricas, ignoran tu porosidad, no estudian tu tono de piel — y el resultado siempre es el mismo: cabello dañado, color que no dura, o una transformación que se ve exactamente igual que la de todas las demás.',
      p5: 'Pero existe una diferencia enorme entre alguien que "aplica color"… y una colorista que entiende tu cabello.',
      p6_1: 'Y esa diferencia tiene nombre. Tiene dirección. Y tiene ',
      p6_highlight: 'más de 15 años de experiencia en Queens, Nueva York.',
    },
    problem: {
      title1: 'El problema no eres ',
      titleHighlight: 'tú',
      title2: ' — es el sistema',
      subtitle:
        '¿Cansada de gastar tu tiempo y energía en salones que nunca te dan lo que realmente quieres?',
      p1: 'Seamos honestas.',
      p2: 'Has estado en ese salón. El que parece lindo por fuera, pero por dentro te atienden apuradas, te hacen la misma consulta de 3 minutos que le hacen a todas, y cuando te miras en el espejo…',
      p3: 'El color no es el que pediste. El acabado no dura ni dos semanas. Y lo peor: nadie te explica por qué.',
      p4: 'O quizás has vivido algo más doloroso — confiaste en alguien con tu cabello oscuro y querías un rubio hermoso… y terminaste con un naranja de pesadilla, una textura rota, o pagando el doble para que alguien lo arreglara.',
      p5: 'Eso no debería pasarle a ninguna mujer. Y no tiene que seguir pasándote a ti.',
      p6: 'La mayoría de los salones trabajan como una fábrica. Cliente entra. Colorista aplica. Cliente sale. Siguiente.',
      p7: 'No hay análisis real. No hay consulta de verdad. No hay fórmula personalizada basada en la porosidad de tu cabello, tu historial de color, tu tono de piel, o lo que realmente necesita tu melena para mantenerse sana mientras se transforma.',
      p8: 'Y el resultado siempre es el mismo:',
      points: [
        'Cabello que se rompe después de aclarar',
        'Color que se va en tres lavadas',
        'Un balayage que parece balayage de revista por una semana… y luego se ve plano y sin vida',
        'Tú, guardando la esperanza de que esta vez será diferente',
      ],
      conclusion1: 'Pero nunca lo es. Porque el problema no es tu cabello.',
      conclusion2:
        'El problema es que nunca has estado en las manos correctas.',
    },
    solution: {
      title1: 'Hasta que descubres que existe ',
      titleHighlight: 'otra forma',
      p1: 'Imagina entrar a un lugar donde desde el primer segundo todo es diferente.',
      p2: 'Donde te reciben con una sonrisa real, no la de protocolo. Donde te hacen una consulta de verdad — te preguntan tu historia, tu cabello, lo que has probado antes, lo que sueñas lograr. Donde antes de tocar tu cabello, ya tienen un plan personalizado, una fórmula calculada, y una visión clara del resultado.',
      p3: 'Donde la colorista que te atiende lleva más de 15 años dominando la ciencia del color, perfeccionando técnicas de balayage, estudiando colorimetría avanzada, y formándose continuamente para traerte las últimas tendencias con resultados que duran.',
      p4: 'Y donde, cuando te miras en el espejo al final…',
      p5_1: 'No solo te ves ',
      p5_highlight: 'hermosa',
      p5_2: '. Te sientes tú. Mejor versión de ti.',
    },
    science: {
      title: 'La diferencia está en cómo trabajamos',
      subtitle: 'Y empieza mucho antes de tocarte el cabello',
      p1_1: 'La colorimetría no es magia. Es ciencia. Y en ',
      p1_highlight: 'Riam Beauty Studio',
      p1_2: ' lo sabemos mejor que nadie. Antes de aplicar cualquier fórmula, hacemos lo que la mayoría de salones simplemente ignora:',
      items: [
        {
          title: 'Porosidad del cabello',
          desc: 'Determina cómo absorbe el color y qué fórmula usar',
        },
        {
          title: 'Fondo de aclaración',
          desc: 'Evita tonos no deseados como el naranja o el amarillo intenso',
        },
        {
          title: 'Historial de color',
          desc: 'Protege la estructura del cabello en procesos acumulativos',
        },
        {
          title: 'Tono de piel y estilo de vida',
          desc: 'El color debe complementarte a ti, no a la tendencia genérica',
        },
        {
          title: 'Nivel de daño actual',
          desc: 'Determina si necesitas tratamiento antes, durante o después',
        },
      ],
      conclusion_1: 'Porque un color bonito no ocurre por ',
      conclusion_highlight: 'suerte',
      conclusion_2:
        '. Se crea con conocimiento, técnica y la experiencia de quien ha visto miles de cabellos… y sabe exactamente qué necesita el tuyo.',
    },
    whatIncluded: {
      title1: '¿Qué Incluye Tu Visita a ',
      titleHighlight: 'Riam Beauty Studio',
      title2: '?',
      subtitle:
        'Cuando reservas una cita con nosotros, no estás pagando solo por un servicio de cabello. Estás invirtiendo en una experiencia completa de transformación:',
      items: [
        {
          title: 'Consulta personalizada',
          desc: 'analizamos tu cabello, tu historia y tu visión',
        },
        {
          title: 'Diagnóstico de colorimetría',
          desc: 'fórmula diseñada solo para ti',
        },
        {
          title: 'Técnicas avanzadas',
          desc: 'balayage, corrección de color y extensiones de nivel profesional',
        },
        {
          title: 'Productos premium',
          desc: 'Truss Professional, Olaplex y más',
        },
        {
          title: 'Educación capilar',
          desc: 'aprendes a mantener tu cabello hermoso en casa',
        },
        {
          title: 'Ambiente de lujo',
          desc: 'y relajación — porque tu tiempo merece ser especial',
        },
        {
          title: 'Atención personalizada',
          desc: 'aquí nunca serás un número más',
        },
      ],
    },
    gallery: {
      subtitle: 'Transformaciones Reales',
      title1: 'Donde la belleza se convierte en ',
      titleHighlight: 'arte',
      followUs: 'Síguenos',
    },
    services: {
      title: 'Nuestros Servicios',
      items: [
        {
          title: 'Color',
          desc: 'Balayage, Corrección de Color, Highlights, Toner, Gloss, Raíces',
        },
        {
          title: 'Rubios',
          desc: 'Rubio Platino, Balayage Ombre, Dimensional Balayage, Doble Proceso — el Best Balayage in Queens',
        },
        {
          title: 'Corte & Estilo',
          desc: 'Corte, Blowout, Updos, Trenzas, Planchado',
        },
        {
          title: 'Tratamientos',
          desc: 'Keratina, Botox Capilar, Olaplex, Hidratación, Truss K-Recovery',
        },
        { title: 'Extensiones', desc: 'Tape-In, K-Tip, Weft, Remoción' },
        {
          title: 'Maquillaje',
          desc: 'Bodas, Quinceañeras, Graduaciones, Eventos Especiales',
        },
        { title: 'Pestañas', desc: 'Pestañas volumen, Riam LuxeLashes' },
      ],
      cta: 'VER LISTA COMPLETA Y PRECIOS',
    },
    guarantee: {
      title1: 'Nuestra Garantía de ',
      titleHighlight: 'Confianza',
      p1_1: 'En ',
      p1_highlight: 'Riam Beauty Studio',
      p1_2: ' no comenzamos un servicio sin que tú estés completamente segura de lo que haremos.',
      items: [
        'Si no quedas 100% satisfecha con la consulta, te explicamos exactamente qué ajustar antes de comenzar.',
        'Usamos solo productos profesionales que cuidan la salud de tu cabello.',
        'Cada resultado está diseñado para tu cabello, tu tono de piel, tu estilo de vida.',
      ],
      conclusion_1:
        'No estamos aquí para hacerte un color genérico. Estamos aquí para crear la versión más ',
      conclusion_highlight: 'auténtica',
      conclusion_2: ' de ti.',
    },
    story: {
      title1: 'La historia detrás de ',
      titleHighlight: 'Riam Beauty Studio',
      p1_1: '',
      p1_highlight: 'Riam Beauty Studio',
      p1_2: ' nació de un sueño — y de la fuerza de una mujer que decidió no rendirse.',
      p2_1: '',
      p2_highlight: 'Rosy Añazco',
      p2_2: ' comenzó sola. Con visión, con fe, y con un propósito claro: crear un espacio donde las mujeres pudieran sentirse hermosas, valoradas, escuchadas y seguras de sí mismas.',
      p3_1: 'No quería un salón más. Quería un ',
      p3_highlight: 'santuario',
      p3_2: '.',
      p4: 'Un lugar donde el lujo no es solo el resultado final, sino cada detalle del camino: la consulta personalizada, el ambiente calmado, los productos de alta calidad, la educación que se lleva cada clienta a casa, y la conexión genuina entre mujer y estilista.',
      p5: 'Con el tiempo, llegaron mujeres increíbles. Clientas que se convirtieron en familia. Talento que se unió al equipo. Y un pequeño salón en Sunnyside que hoy tiene más de 93 reseñas de 5 estrellas y clientas que viajan desde New Jersey solo para sentarse en esa silla.',
      quote_1:
        '"Creo profundamente en el poder de la mente, de las energías y de apoyarnos entre ',
      quote_highlight: 'mujeres',
      quote_2:
        '. Porque cuando una mujer crece, inspira a otras a crecer también."',
      founder: 'Rosy Añazco',
      founderTitle: 'fundadora',
      p6_1: 'Hoy, ',
      p6_highlight: 'Riam Beauty Studio',
      p6_2: ' es reconocido por Parisien Beauty School por el Best Balayage in Queens, además de color y maquillaje, en Nueva York.',
      p7: 'Y sigue creciendo. Porque cada mujer que entra por esa puerta merece lo mejor.',
    },
    testimonials: {
      title: 'Lo Que Dicen Las Mujeres Que Ya Han Estado Aquí',
      subtitle: 'Más de 93 reseñas de 5 estrellas en Google y Booksy',
      reviews: [
        {
          name: 'Bianca P.',
          text: 'Mi cabello natural es muy negro, grueso y crece muy rápido. Siempre me tiño de rubio platino desde la raíz. Rosy hace un trabajo increíble eliminando el brassiness y no rompe mi cabello como otros han hecho. Vale cada kilómetro desde New Jersey.',
        },
        {
          name: 'Deborah G.',
          text: 'Tenía el cabello muy oscuro y con un color muy difícil de corregir. Me dijeron que era imposible lograr el rubio que quería. Rosy me dio el balayage rubio más hermoso que he visto. Y lo hizo con amor.',
        },
        {
          name: 'Lorena Q.',
          text: 'Llevo años confiándole el color de mi cabello a las manos mágicas de Rossy y siempre supera mis expectativas. Su amabilidad, dulzura y carisma hacen que cada visita sea una experiencia especial.',
        },
        {
          name: 'Ana L.',
          text: 'Rosy es una verdadera artista del color. Soy una colorista de su calibre aquí en Sunnyside, NY. Está constantemente completando educación continua y trayendo las últimas tendencias.',
        },
        {
          name: 'Samantha N.',
          text: "Vine a Rosy con cabello bastante dañado por otros 'estilistas'. Llevo casi dos años aquí y la calidad del servicio habla por sí sola desde el momento en que llegas al salón.",
        },
        {
          name: 'Haydee A.',
          text: 'Después de llegar a Nueva York, fui a varios estilistas y no encontraba lo que buscaba. Entonces finalmente conocí a Rossy, quien no solo tiene mucha experiencia, sino que también es súper detallista, eficiente e increíblemente honesta.',
        },
        {
          name: 'Davi D.',
          text: 'Rosy es mi estilista desde hace más de 9 años. Sus manos son como magia. Siempre recibo cumplidos por mi cabello.',
        },
        {
          name: 'Melissa C.',
          text: 'Me hice el rubio aperlado soñado con corte y el resultado fue espectacular. El tono quedó perfecto, luminoso y súper elegante.',
        },
      ],
    },
    faq: {
      title: 'Preguntas Frecuentes',
      subtitle: 'Resolvemos tus dudas antes de que te sientes en nuestra silla',
      items: [
        {
          q: 'Es muy caro',
          a: 'Invertir en un buen color una vez es más económico que pagar dos veces para corregir uno malo. Aquí el resultado dura, el cabello queda sano, y sales sintiéndote diferente.',
        },
        {
          q: 'No sé si mi cabello puede lograr ese resultado',
          a: 'Por eso comenzamos con una consulta personalizada y honesta. Si hay algo que debas saber antes de comenzar, te lo decimos. Nunca haremos algo que no sea beneficioso para tu cabello.',
        },
        {
          q: 'No he ido a un salón desde hace mucho tiempo',
          a: 'Perfecto. Así es como te corresponde comenzar: con alguien que evalúa tu cabello desde cero, sin asumir nada.',
        },
        {
          q: '¿Cómo sé que el resultado será como en las fotos?',
          a: 'Más de 93 reseñas reales, fotos de clientas reales, y 15+ años de experiencia. No vendemos fantasías. Creamos resultados.',
        },
        {
          q: 'Quedo lejos / está en Sunnyside',
          a: 'Tenemos clientas que vienen desde New Jersey y Manhattan. Cuando el resultado es real, la distancia no importa.',
        },
        {
          q: '¿Y si no quedo satisfecha?',
          a: 'Siempre comenzamos con una consulta donde acordamos el resultado esperado. Y si algo necesita ajuste, estamos aquí para solucionarlo.',
        },
      ],
    },
    contact: {
      title: 'Encuéntranos',
      addressTitle: 'Dirección',
      phoneTitle: 'Teléfono',
      hoursTitle: 'Horario',
      hoursDesc: 'Lunes–Sábado:\n9 AM – 6 PM',
      reviewsTitle: 'Reseñas',
    },
    finalCta: {
      title1: 'Tu ',
      titleHighlight: 'Momento',
      title2: ' Es Ahora',
      p1: 'Tenemos agenda disponible de Lunes a Sábado, 9 AM a 6 PM en el corazón de Sunnyside, Queens.',
      p2: 'Las citas se llenan rápido — especialmente los fines de semana y para servicios de corrección de color y balayage completo.',
      p3_1: 'Si has llegado hasta aquí, tu cabello ya está listo para la transformación que ',
      p3_highlight: 'merece',
      p3_2: '.',
      cta: 'RESERVAR MI CITA AHORA',
      quote_1:
        '"Eres demasiado valiosa para seguir saliendo decepcionada. Es hora de ',
      quote_highlight: 'Riam',
      quote_2: '."',
    },
    footer: {
      quote_1:
        '"Aquí no hacemos servicios. Creamos experiencias. Creamos momentos. Creamos ',
      quote_highlight: 'confianza',
      quote_2: '."',
      privacy: 'Política de Privacidad',
      terms: 'Términos y Condiciones',
    },
    legalModal: {
      privacyTitle: 'Política de Privacidad',
      termsTitle: 'Términos y Condiciones',
      lastUpdatedLabel: 'Última actualización',
      lastUpdatedDate: 'Junio 2026',
      closeLabel: 'Cerrar',
      privacy: [
        {
          heading: '1. Información que recopilamos',
          body: 'En Riam Beauty Studio recopilamos información personal que usted nos proporciona voluntariamente al reservar una cita, suscribirse a nuestras comunicaciones o contactarnos: nombre, número de teléfono, correo electrónico y preferencias de servicio.',
        },
        {
          heading: '2. Cómo usamos su información',
          body: 'Utilizamos su información para gestionar reservas, brindar atención personalizada, enviarle recordatorios de citas y, ocasionalmente, comunicarle promociones especiales. Nunca compartimos sus datos con terceros con fines de marketing.',
        },
        {
          heading: '3. Seguridad de los datos',
          body: 'Implementamos medidas técnicas y organizativas razonables para proteger su información personal contra acceso no autorizado, pérdida o divulgación.',
        },
        {
          heading: '4. Sus derechos',
          body: 'Usted tiene derecho a acceder, corregir o solicitar la eliminación de sus datos personales en cualquier momento. Para ejercer estos derechos, contáctenos al (929) 979-4936.',
        },
        {
          heading: '5. Cookies',
          body: 'Este sitio web puede utilizar cookies para mejorar su experiencia de navegación. Puede configurar su navegador para rechazarlas si lo desea.',
        },
        {
          heading: '6. Cambios a esta política',
          body: 'Nos reservamos el derecho de actualizar esta política. Cualquier cambio será publicado en esta página con la fecha de actualización correspondiente.',
        },
        {
          heading: '7. Contacto',
          body: 'Para cualquier consulta sobre esta política, escríbanos o visítenos en 40-17 48th Ave, Sunnyside, NY 11104.',
        },
      ],
      terms: [
        {
          heading: '1. Aceptación de términos',
          body: 'Al reservar un servicio o utilizar nuestro sitio web, usted acepta estos términos y condiciones. Si no está de acuerdo, le pedimos no utilizar nuestros servicios.',
        },
        {
          heading: '2. Reservas y cancelaciones',
          body: 'Las reservas se realizan a través de Booksy o por teléfono. Solicitamos un aviso mínimo de 24 horas para cancelar o reprogramar una cita. Las cancelaciones tardías o ausencias reiteradas pueden requerir un depósito para futuras reservas.',
        },
        {
          heading: '3. Consultas previas',
          body: 'Todo servicio comienza con una consulta personalizada. En Riam Beauty Studio no iniciamos un servicio sin que usted esté completamente segura del resultado deseado.',
        },
        {
          heading: '4. Garantía de servicio',
          body: 'Si no queda satisfecha con la consulta inicial, ajustaremos el plan antes de comenzar. Una vez completado el servicio, los ajustes posteriores estarán sujetos a evaluación.',
        },
        {
          heading: '5. Precios y pagos',
          body: 'Los precios pueden variar según el largo, condición del cabello y servicios adicionales. La cotización final se confirma durante la consulta. Aceptamos efectivo y tarjetas principales.',
        },
        {
          heading: '6. Propiedad intelectual',
          body: 'Todo el contenido, imágenes y marca de este sitio son propiedad de Riam Beauty Studio y están protegidos por las leyes de propiedad intelectual aplicables.',
        },
        {
          heading: '7. Responsabilidad',
          body: 'Riam Beauty Studio no se hace responsable por reacciones alérgicas no reportadas previamente. Le pedimos informar cualquier alergia o sensibilidad antes del servicio.',
        },
        {
          heading: '8. Contacto',
          body: 'Para cualquier consulta sobre estos términos, contáctenos al (929) 979-4936 o visítenos en 40-17 48th Ave, Sunnyside, NY 11104.',
        },
      ],
    },
  },
  en: {
    nav: {
      inicio: 'Home',
      galeria: 'Gallery',
      servicios: 'Services',
      historia: 'Story',
      testimonios: 'Reviews',
      contacto: 'Contact',
      reservar: 'Book Appointment',
      reservarCorto: 'Book',
    },
    hero: {
      title1:
        'Tired of leaving the salon feeling exactly the same as when you walked in',
      titleHighlight: '?',
      title2: '',
      subtitle1: 'The luxury ',
      subtitleHighlight: 'beauty studio',
      subtitle2:
        ' in Sunnyside — the Luxury Hair Salon in Queens that is changing how women feel about themselves.',
      cta: 'BOOK MY APPOINTMENT NOW',
      socialProof: '4.8 ★ Google · 5.0 ★ Booksy · 93+ reviews',
    },
    opening: {
      p1_1: 'Remember the last time you left a salon and truly ',
      p1_highlight: 'loved',
      p1_2: ' what you saw in the mirror?',
      p2_1: 'Not the "it\'s okay." Not the "I guess it\'s fine." But that moment when you look at yourself and think: ',
      p2_highlight_1: '',
      p2_highlight_wow: 'Wow',
      p2_highlight_2: ', this is exactly what I wanted!',
      p3: "If that moment has been hard to find... it's not your fault.",
      p4: "The reality is that most salons work fast, like an assembly line, and apply color without truly analyzing your hair. They mix generic formulas, ignore your porosity, don't study your skin tone — and the result is always the same: damaged hair, color that fades quickly, or a transformation that looks exactly like everyone else's.",
      p5: 'But there is a huge difference between someone who "applies color"... and a colorist who understands your hair.',
      p6_1: 'And that difference has a name. It has an address. And it has ',
      p6_highlight: 'over 15 years of experience in Queens, New York.',
    },
    problem: {
      title1: "The problem isn't ",
      titleHighlight: 'you',
      title2: " — it's the system",
      subtitle:
        'Tired of wasting your time and energy in salons that never give you what you really want?',
      p1: "Let's be honest.",
      p2: "You've been to that salon. The one that looks cute on the outside, but inside they rush you, give you the same 3-minute consultation they give everyone else, and when you look in the mirror...",
      p3: "The color isn't what you asked for. The finish doesn't even last two weeks. And the worst part: no one explains why.",
      p4: "Or maybe you've experienced something more painful — you trusted someone with your dark hair and wanted a beautiful blonde... and ended up with a nightmare orange, broken texture, or paying double to have someone fix it.",
      p5: "That shouldn't happen to any woman. And it doesn't have to keep happening to you.",
      p6: 'Most salons work like a factory. Client in. Colorist applies. Client out. Next.',
      p7: "There is no real analysis. No real consultation. No custom formula based on your hair's porosity, color history, skin tone, or what your hair actually needs to stay healthy while transforming.",
      p8: 'And the result is always the same:',
      points: [
        'Hair that breaks after lightening',
        'Color that washes out in three washes',
        'A balayage that looks magazine-ready for a week... and then looks flat and lifeless',
        'You, holding out hope that this time will be different',
      ],
      conclusion1: "But it never is. Because the problem isn't your hair.",
      conclusion2: "The problem is that you've never been in the right hands.",
    },
    solution: {
      title1: 'Until you discover there is ',
      titleHighlight: 'another way',
      p1: 'Imagine walking into a place where from the very first second, everything is different.',
      p2: "Where they welcome you with a real smile, not a protocol one. Where they give you a real consultation — they ask about your history, your hair, what you've tried before, what you dream of achieving. Where before touching your hair, they already have a custom plan, a calculated formula, and a clear vision of the result.",
      p3: 'Where the colorist attending you has spent over 15 years mastering the science of color, perfecting balayage techniques, studying advanced colorimetry, and continuously training to bring you the latest trends with results that last.',
      p4: 'And where, when you look in the mirror at the end...',
      p5_1: "You don't just look ",
      p5_highlight: 'beautiful',
      p5_2: '. You feel like you. The best version of you.',
    },
    science: {
      title: 'The difference is in how we work',
      subtitle: 'And it starts long before we touch your hair',
      p1_1: "Colorimetry isn't magic. It's science. And at ",
      p1_highlight: 'Riam Beauty Studio',
      p1_2: ' we know it better than anyone. Before applying any formula, we do what most salons simply ignore:',
      items: [
        {
          title: 'Hair Porosity',
          desc: 'Determines how it absorbs color and which formula to use',
        },
        {
          title: 'Underlying Pigment',
          desc: 'Prevents unwanted tones like intense orange or yellow',
        },
        {
          title: 'Color History',
          desc: 'Protects hair structure in cumulative processes',
        },
        {
          title: 'Skin Tone & Lifestyle',
          desc: 'The color should complement you, not a generic trend',
        },
        {
          title: 'Current Damage Level',
          desc: 'Determines if you need treatment before, during, or after',
        },
      ],
      conclusion_1: "Because beautiful color doesn't happen by ",
      conclusion_highlight: 'luck',
      conclusion_2:
        '. It is created with knowledge, technique, and the experience of someone who has seen thousands of heads of hair... and knows exactly what yours needs.',
    },
    whatIncluded: {
      title1: 'What Does Your Visit to ',
      titleHighlight: 'Riam Beauty Studio',
      title2: ' Include?',
      subtitle:
        "When you book an appointment with us, you're not just paying for a hair service. You're investing in a complete transformation experience:",
      items: [
        {
          title: 'Custom Consultation',
          desc: 'we analyze your hair, your history, and your vision',
        },
        {
          title: 'Colorimetry Diagnosis',
          desc: 'formula designed just for you',
        },
        {
          title: 'Advanced Techniques',
          desc: 'professional-level balayage, color correction, and extensions',
        },
        {
          title: 'Premium Products',
          desc: 'Truss Professional, Olaplex, and more',
        },
        {
          title: 'Hair Education',
          desc: 'you learn how to maintain your beautiful hair at home',
        },
        {
          title: 'Luxury Atmosphere',
          desc: 'and relaxation — because your time deserves to be special',
        },
        {
          title: 'Personalized Attention',
          desc: 'here you will never be just another number',
        },
      ],
    },
    gallery: {
      subtitle: 'Real Transformations',
      title1: 'Where beauty becomes ',
      titleHighlight: 'art',
      followUs: 'Follow us',
    },
    services: {
      title: 'Our Services',
      items: [
        {
          title: 'Color',
          desc: 'Balayage, Color Correction, Highlights, Toner, Gloss, Roots',
        },
        {
          title: 'Blondes',
          desc: 'Platinum Blonde, Balayage Ombre, Dimensional Balayage, Double Process — the Best Balayage in Queens',
        },
        {
          title: 'Cut & Style',
          desc: 'Haircut, Blowout, Updos, Braids, Flat Iron',
        },
        {
          title: 'Treatments',
          desc: 'Keratin, Hair Botox, Olaplex, Hydration, Truss K-Recovery',
        },
        { title: 'Extensions', desc: 'Tape-In, K-Tip, Weft, Removal' },
        {
          title: 'Makeup',
          desc: 'Weddings, Quinceañeras, Graduations, Special Events',
        },
        { title: 'Lashes', desc: 'Volume Lashes, Riam LuxeLashes' },
      ],
      cta: 'VIEW FULL LIST AND PRICES',
    },
    guarantee: {
      title1: 'Our Guarantee of ',
      titleHighlight: 'Trust',
      p1_1: 'At ',
      p1_highlight: 'Riam Beauty Studio',
      p1_2: ' we do not start a service without you being completely sure of what we will do.',
      items: [
        'If you are not 100% satisfied with the consultation, we explain exactly what to adjust before starting.',
        "We use only professional products that care for your hair's health.",
        'Every result is designed for your hair, your skin tone, your lifestyle.',
      ],
      conclusion_1:
        'We are not here to give you a generic color. We are here to create the most ',
      conclusion_highlight: 'authentic',
      conclusion_2: ' version of you.',
    },
    story: {
      title1: 'The story behind ',
      titleHighlight: 'Riam Beauty Studio',
      p1_1: '',
      p1_highlight: 'Riam Beauty Studio',
      p1_2: ' was born from a dream — and the strength of a woman who decided not to give up.',
      p2_1: '',
      p2_highlight: 'Rosy Añazco',
      p2_2: ' started alone. With vision, faith, and a clear purpose: to create a space where women could feel beautiful, valued, heard, and confident.',
      p3_1: "She didn't want just another salon. She wanted a ",
      p3_highlight: 'sanctuary',
      p3_2: '.',
      p4: "A place where luxury isn't just the final result, but every detail of the journey: the personalized consultation, the calm atmosphere, the high-quality products, the education each client takes home, and the genuine connection between woman and stylist.",
      p5: 'Over time, incredible women arrived. Clients who became family. Talent that joined the team. And a small salon in Sunnyside that today has over 93 5-star reviews and clients who travel from New Jersey just to sit in that chair.',
      quote_1:
        '"I deeply believe in the power of the mind, of energies, and of supporting each other as ',
      quote_highlight: 'women',
      quote_2:
        '. Because when one woman grows, she inspires others to grow too."',
      founder: 'Rosy Añazco',
      founderTitle: 'founder',
      p6_1: 'Today, ',
      p6_highlight: 'Riam Beauty Studio',
      p6_2: ' is recognized by Parisien Beauty School for the Best Balayage in Queens, plus expert color and makeup, in New York.',
      p7: 'And it keeps growing. Because every woman who walks through that door deserves the best.',
    },
    testimonials: {
      title: 'What Women Who Have Been Here Say',
      subtitle: 'Over 93 5-star reviews on Google and Booksy',
      reviews: [
        {
          name: 'Bianca P.',
          text: "My natural hair is very black, thick, and grows very fast. I always dye it platinum blonde from the root. Rosy does an incredible job removing brassiness and doesn't break my hair like others have done. Worth every mile from New Jersey.",
        },
        {
          name: 'Deborah G.',
          text: "I had very dark hair with a very difficult color to correct. I was told it was impossible to achieve the blonde I wanted. Rosy gave me the most beautiful blonde balayage I've ever seen. And she did it with love.",
        },
        {
          name: 'Lorena Q.',
          text: "I have trusted my hair color to Rossy's magical hands for years and she always exceeds my expectations. Her kindness, sweetness, and charisma make every visit a special experience.",
        },
        {
          name: 'Ana L.',
          text: 'Rosy is a true color artist. I am a colorist of her caliber here in Sunnyside, NY. She is constantly completing continuing education and bringing the latest trends.',
        },
        {
          name: 'Samantha N.',
          text: "I came to Rosy with pretty damaged hair from other 'stylists'. I've been coming here for almost two years and the quality of service speaks for itself from the moment you arrive at the salon.",
        },
        {
          name: 'Haydee A.',
          text: "After arriving in New York, I went to several stylists and couldn't find what I was looking for. Then I finally met Rossy, who not only has a lot of experience, but is also super detailed, efficient, and incredibly honest.",
        },
        {
          name: 'Davi D.',
          text: 'Rosy has been my stylist for over 9 years. Her hands are like magic. I always get compliments on my hair.',
        },
        {
          name: 'Melissa C.',
          text: 'I got my dream pearly blonde with a cut and the result was spectacular. The tone was perfect, luminous, and super elegant.',
        },
      ],
    },
    faq: {
      title: 'Frequently Asked Questions',
      subtitle: 'We answer your questions before you sit in our chair',
      items: [
        {
          q: "It's too expensive",
          a: 'Investing in good color once is cheaper than paying twice to fix a bad one. Here the result lasts, your hair stays healthy, and you leave feeling different.',
        },
        {
          q: "I don't know if my hair can achieve that result",
          a: "That's why we start with a personalized and honest consultation. If there's anything you should know before starting, we tell you. We will never do something that isn't beneficial for your hair.",
        },
        {
          q: "I haven't been to a salon in a long time",
          a: "Perfect. That's exactly how you should start: with someone who evaluates your hair from scratch, without assuming anything.",
        },
        {
          q: 'How do I know the result will look like the photos?',
          a: "Over 93 real reviews, photos of real clients, and 15+ years of experience. We don't sell fantasies. We create results.",
        },
        {
          q: "I live far away / it's in Sunnyside",
          a: "We have clients who come from New Jersey and Manhattan. When the result is real, distance doesn't matter.",
        },
        {
          q: "What if I'm not satisfied?",
          a: 'We always start with a consultation where we agree on the expected result. And if something needs adjusting, we are here to fix it.',
        },
      ],
    },
    contact: {
      title: 'Find Us',
      addressTitle: 'Address',
      phoneTitle: 'Phone',
      hoursTitle: 'Hours',
      hoursDesc: 'Monday–Saturday:\n9 AM – 6 PM',
      reviewsTitle: 'Reviews',
    },
    finalCta: {
      title1: 'Your ',
      titleHighlight: 'Moment',
      title2: ' Is Now',
      p1: 'We have availability Monday to Saturday, 9 AM to 6 PM in the heart of Sunnyside, Queens.',
      p2: 'Appointments fill up fast — especially on weekends and for color correction and full balayage services.',
      p3_1: "If you've made it this far, your hair is ready for the transformation it ",
      p3_highlight: 'deserves',
      p3_2: '.',
      cta: 'BOOK MY APPOINTMENT NOW',
      quote_1:
        '"You are too valuable to keep leaving disappointed. It\'s time for ',
      quote_highlight: 'Riam',
      quote_2: '."',
    },
    footer: {
      quote_1:
        '"Here we don\'t just do services. We create experiences. We create moments. We create ',
      quote_highlight: 'confidence',
      quote_2: '."',
      privacy: 'Privacy Policy',
      terms: 'Terms and Conditions',
    },
    legalModal: {
      privacyTitle: 'Privacy Policy',
      termsTitle: 'Terms and Conditions',
      lastUpdatedLabel: 'Last updated',
      lastUpdatedDate: 'June 2026',
      closeLabel: 'Close',
      privacy: [
        {
          heading: '1. Information we collect',
          body: 'At Riam Beauty Studio we collect personal information you voluntarily provide when booking an appointment, subscribing to our communications, or contacting us: name, phone number, email, and service preferences.',
        },
        {
          heading: '2. How we use your information',
          body: 'We use your information to manage bookings, provide personalized service, send appointment reminders, and occasionally share special promotions. We never share your data with third parties for marketing purposes.',
        },
        {
          heading: '3. Data security',
          body: 'We implement reasonable technical and organizational measures to protect your personal information against unauthorized access, loss, or disclosure.',
        },
        {
          heading: '4. Your rights',
          body: 'You have the right to access, correct, or request deletion of your personal data at any time. To exercise these rights, contact us at (929) 979-4936.',
        },
        {
          heading: '5. Cookies',
          body: 'This website may use cookies to improve your browsing experience. You can configure your browser to reject them if you wish.',
        },
        {
          heading: '6. Changes to this policy',
          body: 'We reserve the right to update this policy. Any changes will be posted on this page with the corresponding update date.',
        },
        {
          heading: '7. Contact',
          body: 'For any questions about this policy, write to us or visit us at 40-17 48th Ave, Sunnyside, NY 11104.',
        },
      ],
      terms: [
        {
          heading: '1. Acceptance of terms',
          body: 'By booking a service or using our website, you accept these terms and conditions. If you do not agree, we ask you not to use our services.',
        },
        {
          heading: '2. Bookings and cancellations',
          body: 'Bookings are made through Booksy or by phone. We ask for a minimum of 24 hours notice to cancel or reschedule an appointment. Late cancellations or repeated no-shows may require a deposit for future bookings.',
        },
        {
          heading: '3. Pre-service consultation',
          body: 'Every service begins with a personalized consultation. At Riam Beauty Studio we do not start a service without you being completely sure of the desired result.',
        },
        {
          heading: '4. Service guarantee',
          body: 'If you are not satisfied with the initial consultation, we will adjust the plan before starting. Once the service is completed, subsequent adjustments will be subject to evaluation.',
        },
        {
          heading: '5. Pricing and payments',
          body: 'Prices may vary based on length, hair condition, and additional services. The final quote is confirmed during the consultation. We accept cash and major cards.',
        },
        {
          heading: '6. Intellectual property',
          body: 'All content, images, and branding on this site are the property of Riam Beauty Studio and are protected by applicable intellectual property laws.',
        },
        {
          heading: '7. Liability',
          body: 'Riam Beauty Studio is not responsible for previously unreported allergic reactions. Please inform us of any allergies or sensitivities before service.',
        },
        {
          heading: '8. Contact',
          body: 'For any questions about these terms, contact us at (929) 979-4936 or visit us at 40-17 48th Ave, Sunnyside, NY 11104.',
        },
      ],
    },
  },
}
